<template>
    <div id="app">
        <v-app>
            <v-main>
                <v-container fluid fill-height pa-0>
                    <v-slide-y-transition mode="out-in">
                        <router-view/>
                    </v-slide-y-transition>
                </v-container>
                <global-snackbar/>
            </v-main>
        </v-app>
        <audio src="/static/audio/new.wav" id="audio" style="opacity: 0;"></audio>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import io from 'socket.io-client'
    import config from './config/index'
    import globalSnackbar from './components/Snackbar/Layout'

    export default {
        name: 'horeca-app',
        components: { globalSnackbar },
        data: () => ({
            projectKey: ''
        }),
        mounted () {
            this.$store.watch(
                (state, getters) => getters.getUser,
                (newValue, oldValue) => {
                    if (newValue.role_id === 3) {
                        const audio = document.getElementById('audio');
                        const socket = io.connect(config.socketUrl, { reconnect: true });

                        socket.on(`new_order-${newValue.channel_id}`, data => {
                            this.$store.commit('storeOrder', data.order)
                            this.$store.commit('showSnackbar', {
                                text: 'Получен новый заказ',
                                color: 'info'
                            })
                            audio.play()
                        })

                        socket.on(`booking-${newValue.channel_id}`, data => {
                            this.$store.commit('storeBooking', data.booking)
                            this.$store.commit('showSnackbar', {
                                text: 'Получено новое бронирование столика',
                                color: 'info'
                            })
                            audio.play()
                        })
                    }
                }
            )
        },
        created () {
            let user = sessionStorage.getItem('user');
            if (user) {
                let userObject = JSON.parse(user)
                if (userObject) {
                    let projectKey = userObject.data.project.projectKey
                    if (projectKey) {
                        this.$store.commit('loginUser', userObject)
                    }
                }
            }

            this.setHeaderTitle('Главная')
        },

        computed: mapState([
            'getUser'
        ])
    }
</script>

<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700|Material+Icons");
    @import "~vue-wysiwyg/dist/vueWysiwyg.css";
    @import "assets/styles/reset";
    @import "assets/styles/custom";
</style>
